import React from "react";
import "../styles/Landingpage.css";
import Logo from "../Assets/imgs/logo.webp";
import mainimage from "../Assets/imgs/landingpage.webp";
import { Spinner } from "react-bootstrap";

type Props = {
  msisdn: string;
  handleUserMsisdnInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleOnpressContinueBtn: () => void;
  error: string;
  loader: boolean;
  showErro: boolean;
};

const LandingPage = (props: Props) => {
  return (
    <div className="landing-bg">
      <div className="subscrption-page">
        <div className="subscrption-logo">
          <img src={Logo} alt="logo image" width={125} height={40} />
        </div>
      </div>

      <div className="subscrption-content">
        <div className="subscrption-inner">
          <div className="image">
            <img src={mainimage} width={355} height={355} alt="image" />
          </div>
          <div className="form">
            <div className="input-content">
              <div className="text">Please enter a 10-digit mobile number.</div>
              <div className="code-number">
                <div className="code">
                  <div className="fixed-cnt">+92</div>
                </div>
                <div className="input">
                  <input
                    type="tel"
                    value={props.msisdn}
                    placeholder="3xx-xxxx-xxx"
                    onChange={(e) => {
                      props.handleUserMsisdnInput(e);
                    }}
                    max={10}
                  />
                </div>
              </div>
            </div>
            {props.showErro ? (
              <>
                <p className="error">{props.error}</p>
              </>
            ) : (
              <></>
            )}

            {props.loader ? (
              <>
                <div className="SpinnerBtn">
                  <button>
                    <Spinner
                      animation="border"
                      className="SpinnerBtn"
                      role="status"
                      style={{ color: "#5424FD" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </button>
                </div>
              </>
            ) : (
              <>
                <button
                  onClick={() => {
                    props.handleOnpressContinueBtn();
                  }}
                >
                 Get OTP
                </button>
              </>
            )}

            {/* <button
              onClick={() => {
                props.handleOnpressContinueBtn();
              }}
            >
              Continue
            </button> */}

            <div className="prepaid-text">Prepaid Charges : Rs 5+T/Day*</div>

            <div className="condition">
              <a href="/privacy-policy" target="_blank">
                Privacy Policy
              </a>
                <span></span>
              <a href="/terms" target="_blank">
                Terms & Conditions{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
